import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { PaymentOption, PaymentOptions } from '../../models/payment-options'
import { PaymentAccount } from '../../models/payment-account'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { PortalGlobals } from '../../../portalglobals'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'

@Component({
    selector: 'payment-method',
    templateUrl: './payment-method.component.html'

})
export class PaymentMethodComponent implements OnInit {

    @Output() onPaymentAccountChange: EventEmitter<PaymentAccount> = new EventEmitter<PaymentAccount>()
    @Output() onPaymentOptionChange: EventEmitter<string> = new EventEmitter<string>()

    @Input() paymentOption: string = ""
    @Input() disabled: boolean = false
    @Input() paymentAccount: PaymentAccount = {} as PaymentAccount
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    validators = [new NotBlankGenericFieldValidator()]
    accountInfoFormIsVisible() {
        return this.paymentOption ===   'Automatic Bank Draft Withdrawal'
    }
    orgName: string
    AetnaorgName: string

    constructor(private _enrollService: EnrollmentGateway, public _global: PortalGlobals, private _currentUserGateway: CurrentUserGateway) { }
    enroll: EnrollmentViewModel = {} as EnrollmentViewModel
    ngOnInit() {
        if (this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser()
                .subscribe(user => {
                    if (user != null) {
                        this._global.currentUser = user
                        this.SetPageData()
                    }
                })
        }
        else {
            this.SetPageData()
        }

    }

    paymentFormChange(paymentAccount: PaymentAccount) {
        this.paymentAccount = paymentAccount
        this.onPaymentAccountChange.emit(paymentAccount)
    }

    paymentOptionChanged(option: string) {
        this.paymentOption = option
        this.onPaymentOptionChange.emit(option)
    }

    private SetPageData() {
        this.paymentOptions = [
            {
                value: 'Deduction from Social Security Check',
                htmlLabel: 'Automatic Deduction from Social Security benefit check',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel: 'Automatic Deduction from Railroad Retirement Board benefit check',
                disabled: this.disabled
            },
            {
                value: 'Automatic Bank Draft Withdrawal',
                htmlLabel: 'Automatic Bank Draft Withdrawal from Checking or Savings Account',
                disabled: this.disabled
            },
            {
                value: 'Direct Bill',
                htmlLabel: 'Monthly payments by check',
                disabled: this.disabled
            }
        ]
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem("PLANYEAR") !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem("PLANYEAR"))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.orgName = this._global.currentUser.insuranceCompanyName
            this.AetnaorgName = this._global.currentUser.insuranceCompanyName
        }
        else {
            this.orgName = this._global.insuranceCompanyNameAetna
            this.AetnaorgName = this._global.insCompanyNameAetnaMedicare
        }
        this.enroll = this._enrollService.getEnrollmentViewModel()
        if (this.enroll.PWO !== undefined && this.enroll.PWO !== null) {
            this.paymentOption = this.enroll.PWO
            this.paymentOptionChanged(this.paymentOption)
        }
    }
}